document.addEventListener('DOMContentLoaded',function(){
    const tabItemList = Array.from(document.querySelector(".user-guide-tab-container .tab-header.mobile .swiper-wrapper").children);
    document.querySelectorAll(".tab-header-text").forEach(item=>{
        item.addEventListener('click',function(){
            testSliderItemPos(this);
            document.querySelectorAll(".user-guide-tab .active").forEach(activeItem => {
                activeItem.classList.remove('active');
            });
            this.classList.add('active');
            if(this.closest(".tab-header.desktop")) {
                const i = Array.from(this.parentElement.children).indexOf(this);
                this.closest(".tab-wrapper").querySelectorAll(".tab_pannel")[i].classList.add('active');
                this.closest(".user-guide-tab").querySelector(".tab-header.mobile")?.querySelectorAll(".tab-header-text")[i].classList.add('active');
            } else {
                const i = Array.from(this.parentElement.querySelectorAll(".tab-header-text")).indexOf(this);
                this.closest(".user-guide-tab").querySelector(".tab-wrapper").querySelectorAll(".tab_pannel")[i].classList.add("active");
                this.closest(".user-guide-tab").querySelector(".tab-header.desktop").querySelectorAll(".tab-header-text")[i].classList.add('active');
            }
        });
    });
    const tabHeaderSlider = new Swiper(".user-guide-tab-container .tab-header.mobile",{
        slidesPerView: 'auto',
        spaceBetween: 6
    });

    const testSliderItemPos = (sliderItem) => {
        console.log(sliderItem);
        if(sliderItem) {
            const posData = sliderItem.getBoundingClientRect();
            console.log(posData);
            console.log(screen.availWidth);
            console.log(tabItemList.indexOf(sliderItem));
            if(posData.left < 0 || posData.right > screen.availWidth) {
                tabHeaderSlider.slideTo(tabItemList.indexOf(sliderItem));
            }
        }
    }
});